import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/covered-call',
  component: () => import('../../routes/CoveredCall.svelte'),
  card: {
    id: 'covered-call',
    title: 'Covered Call Return',
    description: 'Calculate premium income, static and assigned returns, annualized yield, and downside protection for covered call strategies.',
    icon: 'sell',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/covered-call',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Covered Call Return Calculator – Premium Income & Annualized Yield Calculator',
    description: 'Free covered call return calculator. Calculate premium income, static and assigned returns, annualized yield, downside protection, and break-even price for covered call options strategies.',
  },
};

export default meta;
